import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetTimeZone } from '../../utils/dateTimeFormat';
import { AuthService } from '@services/auth/auth.service';
import { DEFAULT_CONFIG } from '@config/app.config';

@Injectable()
export class ApiVersioningInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const timeZone = GetTimeZone();
    const version = '1.0';

    //get current language
    const currentLangIndex = this.authService.getDefaultLanguageIndex();
    const currentLang = DEFAULT_CONFIG.translateLanguages[currentLangIndex];

    let headers = req.headers;

    const skipDefaultHeaders = headers.has('x-no-default-headers');
    if (skipDefaultHeaders) {
      headers = headers.delete('x-no-default-headers');
    } else {
      headers = headers
        .set('Accept', `application/vnd.unipet.v${version}+json`)
        .set('Content-Type', `application/vnd.unipet.v${version}+json`);
    }

    headers = headers
      .set('timezone', timeZone)
      .set('Accept-Language', currentLang)
      .delete('version');

    const clonedRequest = req.clone({ headers });

    return next.handle(clonedRequest);
  }
}
